/* eslint-disable react/jsx-no-target-blank */
import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useMenuCountStore } from '../../../../app/core/state-management/states/menuCount';
import { apiCaller } from '../../../../app/core/hooks/useApi';
import { ServiceAgent } from '../../../../app/core/services/serviceAgent';
import { useEffect } from 'react';
import { useWroteStore } from '../../../../app/core/state-management/states/wrote';
import { useCardtableStore } from '../../../../app/core/state-management/states/cardtable/index2';
import { useAuth } from '../../../../app/modules/auth';
import { isValidRole, RoleNameEnum } from '../../../../app/core/utils/util';
import { useSupervisionMenuCountStore } from '../../../../app/core/state-management/states/supervisionMenuCount';

export function AsideMenuMain() {
  const intl = useIntl();

  const { userInfo } = useAuth();

  const { dispatch, state } = useMenuCountStore();
  const { dispatch: dispatchSupervisionMenuCount, state: steteSupervisionMenuCount } = useSupervisionMenuCountStore();

  const { state: worteState } = useWroteStore();
  const { state: cardtableState } = useCardtableStore();

  ///states
  const { menuCountInfo } = state;
  const { menuCountInfo: supervisionMenuCountInfo } = steteSupervisionMenuCount;

  const { WroteList } = worteState
  const { CardTableList, RequestData } = cardtableState;

  ////handler
  const getMenuCountData = () => {
    apiCaller({
      api: ServiceAgent.cardtable.request_getmenucount,
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { menuCountInfo: resp?.data?.data },
            type: 'SET_MENUCOUNT_DATA'
          })
        }
      },
    })
  }

  const getSupervisionMenuCountData = () => {
    apiCaller({
      api: ServiceAgent.supervision.request_getmenucount,
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatchSupervisionMenuCount({
            payload: { menuCountInfo: resp?.data?.data },
            type: 'SET_MENUCOUNT_DATA'
          })
        }
      },
    })
  }
  const getNotifications = () => {
    apiCaller({
      api: ServiceAgent.notifications.request_getAll,
      apiArguments: {
        CurrentPage: 1,
        PageSize: 5,
      },
      onSuccess(resp) {
        if (resp?.status === 200 && resp?.data?.statusCode === 200) {
          dispatch({
            payload: { allNotifications: resp?.data?.data?.data },
            type: 'SET_NOTIFICATION_DATA'
          })
        }
      },
    })
  }

  useEffect(() => {
    getMenuCountData()
    getNotifications()
    getSupervisionMenuCountData()
  }, [WroteList, CardTableList, RequestData])

  const userClaims =
    userInfo?.userClaims?.map((x: any) => x.claimValue) || []

  const hasClaims = userClaims.length > 0
  const can = (p?: string) => {
    if (!hasClaims) return true
    if (!p) return true
    return userClaims.includes(p)
  }

  return (
    <>
    {/* DASHBOARD */}
    {(can('Dashboard') || userClaims.length === 0) && (
      <AsideMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      />
    )}
  
    {/* CARTABLE */}
    {(can('Cartable') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/cardboard' title='کارتابل' icon='document'>
        {(can('Cartable.CreditLineFacilities') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-cardtable-list/1' title={`تسهیلات خط اعتباری ${menuCountInfo?.khatEtebari || '0'}`} hasBullet />
        )}
  
        {(can('Cartable.InternalResourcesFacilities') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-cardtable-list/2' title={`تسهیلات منابع داخلی ${menuCountInfo?.manabeDakheli || '0'}`} hasBullet />
        )}
  
        {(can('Cartable.Guarantee') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-cardtable-list/3' title={`ضمانت نامه ${menuCountInfo?.zemanatName || '0'}`} hasBullet />
        )}
  
        {(can('Cartable.BrokerageFacilities') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-cardtable-list/4' title={`تسهیلات کارگزاری ${menuCountInfo?.karqozari || '0'}`} hasBullet />
        )}
  
        {(can('Cartable.Investment') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-cardtable-list/5' title={`سرمایه گذاری خطر پذیر ${menuCountInfo?.khatarpazir || '0'}`} hasBullet />
        )}
  
        {(can('Cartable.AllCartables') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-cardtable-list/6' title={`همه کارتابل ها ${menuCountInfo?.allCardBoard || '0'}`} hasBullet />
        )}
  
        {(can('Cartable.WaitingList') || userClaims.length === 0) && (
          <AsideMenuItem to='/cardtable-waiting-list' title={`لیست انتظار ${menuCountInfo?.weitingList || '0'}`} hasBullet />
        )}
  
        {(can('Cartable.Archive') || userClaims.length === 0) && (
          <AsideMenuItem to='/cardtable-archive-list' title={`بایگانی ${menuCountInfo?.archiveBox || '0'}`} hasBullet />
        )}
      </AsideMenuItemWithSub>
    )}
  
    {/* SUPERVISION */}
    {(can('Supervision') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/supervision' title='بخش نظارت' icon='eye'>
        {(can('Supervision.CreditLineFacilities') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-supervision-list/1' title={`تسهیلات خط اعتباری ${supervisionMenuCountInfo?.khatEtebari || '0'}`} hasBullet />
        )}
  
        {(can('Supervision.InternalResourcesFacilities') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-supervision-list/2' title={`تسهیلات منابع داخلی ${supervisionMenuCountInfo?.manabeDakheli || '0'}`} hasBullet />
        )}
  
        {(can('Supervision.Guarantee') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-supervision-list/3' title={`ضمانت نامه ${supervisionMenuCountInfo?.zemanatName || '0'}`} hasBullet />
        )}
  
        {(can('Supervision.BrokerageFacilities') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-supervision-list/4' title={`تسهیلات کارگزاری ${supervisionMenuCountInfo?.karqozari || '0'}`} hasBullet />
        )}
  
        {(can('Supervision.Investment') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-supervision-list/5' title={`سرمایه گذاری ${supervisionMenuCountInfo?.khatarpazir || '0'}`} hasBullet />
        )}
  
        {(can('Supervision.All') || userClaims.length === 0) && (
          <AsideMenuItem to='/getall-supervision-list/6' title={`همه ${supervisionMenuCountInfo?.allCardBoard || '0'}`} hasBullet />
        )}
      </AsideMenuItemWithSub>
    )}
  
    {/* AUTOMATION */}
    {(can('Automation') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/management-letter' title='اتوماسیون' icon='update-file'>
        {(can('Automation.View') || userClaims.length === 0) && (
          <AsideMenuItem to='/management-letter' title={`مدیریت اتوماسیون ${menuCountInfo?.myLetter || '0'}`} hasBullet />
        )}
      </AsideMenuItemWithSub>
    )}
  
    {/* TRANSCRIPT */}
    {(can('Automation.Copies') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/reminder' title='رونوشت ها' icon='notepad-bookmark'>
        <AsideMenuItem to='/wrote' title={`همه رونوشت ها ${menuCountInfo?.transcript || '0'}`} hasBullet />
      </AsideMenuItemWithSub>
    )}
  
    {/* REQUESTS */}
    {(can('Application.AllRequests') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/request' title='لیست همه درخواست ها' icon='update-file'>
        <AsideMenuItem to='/all-request/1' title='در جریان' hasBullet />
        <AsideMenuItem to='/all-request/2' title='تکمیل شده' hasBullet />
        <AsideMenuItem to='/all-request/3' title='عودت داده شده' hasBullet />
      </AsideMenuItemWithSub>
    )}
  
    {/* LETTERS */}
    {(can('Application.AllLetters') || userClaims.length === 0) && (
      <AsideMenuItem to='/letter' icon='message-question' title='لیست تمامی نامه ها' />
    )}
  
    {/* PERSONNEL */}
    {(can('Personnel') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/personel' title='پرسنل' icon='profile-circle'>
        <AsideMenuItem to='/personel-list' title='مدیریت پرسنل' hasBullet />
      </AsideMenuItemWithSub>
    )}
  
    {/* Q&A */}
    {(can('QAndA') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/survey' title='پرسش و پاسخ' icon='question'>
        <AsideMenuItem to='/survey-category' title='ایجاد برگه نظرسنجی' hasBullet />
      </AsideMenuItemWithSub>
    )}
  
    {/* FINANCE */}
    {(can('Finance.AllTransactions') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/finance' title='مالی' icon='wallet'>
        <AsideMenuItem to='/all-transaction' title='همه تراکنش ها' hasBullet />
      </AsideMenuItemWithSub>
    )}
  
    {/* SUPPORT */}
    {(can('Support') || userClaims.length === 0) && (
      <AsideMenuItem to='/tickets' icon='user' title='پشتیبانی' />
    )}
  
    {/* SUGGESTED TEXTS */}
    {(can('SuggestedTexts') || userClaims.length === 0) && (
      <AsideMenuItem to='/custom-text' icon='text' title='متن های پیشنهادی' />
    )}
  
    {/* ARCHIVE */}
    {(can('LetterArchive') || userClaims.length === 0) && (
      <AsideMenuItem to='/archived-document' icon='paper-clip' title='بایگانی نامه' />
    )}
  
    {/* SUBSCRIPTION */}
    {(can('SubscriptionManagement') || userClaims.length === 0) && (
      <AsideMenuItem to='/plans' icon='dollar' title='مدیریت اشتراک ها' />
    )}
  
    {/* REQUEST FORM */}
    {(can('RequestForm') || userClaims.length === 0) && (
      <AsideMenuItem to='/request-form' icon='send' title='فرم درخواست' />
    )}
  
    {/* TRAINING */}
    {(can('TrainingVideos') || userClaims.length === 0) && (
      <AsideMenuItem to='/support-video' icon='google-play' title='ویدئو های آموزشی' />
    )}
  
    {/* REPORTS */}
    {(can('Reports') || userClaims.length === 0) && (
      <AsideMenuItem to='/reports-navigate' icon='chart' title='گزارشات' />
    )}
  
    {/* FAQ */}
    {(can('FAQ') || userClaims.length === 0) && (
      <AsideMenuItem to='/faq' icon='questionnaire-tablet' title='سوالات متداول' />
    )}
  
    {/* USERS */}
    {(can('Users') || userClaims.length === 0) && (
      <AsideMenuItem to='/user-list' icon='user-tick' title='لیست کاربران' />
    )}
  
    {/* SETTINGS */}
    {(can('Settings') || userClaims.length === 0) && (
      <AsideMenuItemWithSub to='/setting' title='تنظیمات' icon='setting-2'>
        <AsideMenuItem to='/setting-managment' title='تنظیمات CRM' />
      </AsideMenuItemWithSub>
    )}
  </>
  )
}

